<template lang="pug">
	main.page
		template(v-for="(section, index) in sections")
			transition(name="fade" mode="out-in")
				section( v-bind:id="section.type" v-bind:class="'section'" )
					component(v-for="(child, index) in section.childs"
						:is="child.type"
						:key="child.type"
						:content="child"
					)
</template>

<script>

import _ from 'lodash';
import Vue from 'vue';
import store, {ABSPATH} from './../store';

// components
import hero from './features/Hero/';
import detail from './features/Details/';
import movies from './features/Movies/';
import columns from './features/Columns/';
import gallery from './features/Gallery/';
import slider from './features/Slider/';
import logoslider from './features/Logoslider/';
import legals from './features/Legals/';


export default {
	name: 'Page',
	data () {
		return {
			loading: false,
			error: null,
			views: []
		}
	},
	methods: {
		scrollToAnchor() {
			let scrollto = this.$router.currentRoute.query.scrollto || null;
			if(scrollto){
				let anchor = document.querySelector('#'+scrollto) || null;
				if (anchor) setTimeout(() => this.$parent.winScrollTo(anchor), 1100);
			}
		}
	},
	computed:{
		sections() {
			let views = [];
			_.each( store.state.content, (item, key) => {
				views.push({
					type: key,
					childs: item
				});
			});
			return views;
		}
	},
	components: {
		hero,
		detail,
		movies,
		columns,
		gallery,
		slider,
		logoslider,
		legals
	},
	beforeRouteEnter (to, from, next) {
		// Load Page Content
		let pathCollection = to.path.split("/").filter((res) => {  return (res.length >= 1) ? true : false });
		let id = pathCollection.join('/');
		//
		fetch(`${ABSPATH}/${id}`)
			.then( response => response.json() )
			.then( body => {
				store.commit('insertPage', body);
				next(true);
			})
			.catch( next(false) );
	},
	beforeRouteUpdate (to, from, next) {
		// Load Page Content
		let pathCollection = to.path.split("/").filter((res) => {  return (res.length >= 1) ? true : false });
		let id = pathCollection.join('/');
		//
		if(to.query.scrollto){
			next({query: {scrollto: to.query.scrollto}});
		}
		//
		if(to.path != from.path) {
			fetch(`${ABSPATH}/${id}`)
			.then( response => response.json() )
			.then( body => {
				store.commit('insertPage', body);
				next(true);
			})
			.catch( next(false) );
		}
	},
	mounted(){
		this.scrollToAnchor();
	}
}
</script>



// WEBPACK FOOTER //
// src/components/Page.vue